module.exports = __webpack_public_path__ + "img/lipei.926a9637.png";